import { useTranslation } from 'react-i18next';
import { Icon } from '@sendible/design-system/src';
import {
  NoDataContainer,
  NoDataTitle,
  NoDataDescription,
  NoProfilesContainer,
  NoProfilesIcon,
  NoProfilesTitle,
  NoProfilesDescription,
} from './index.styles';

const PROFILE_REASONS: NoDataReason[] = ['no_profiles_selected', 'no_compatible_profiles'];

interface ModuleNoDataProps {
  reason: NoDataReason | null;
  platformLabel?: string;
}

export const ModuleNoData = ({ reason, platformLabel }: ModuleNoDataProps) => {
  const { t } = useTranslation('reports');

  const reasonMessages: Record<NoDataReason, { title: string; description: string }> = {
    empty_result: {
      title: t('new_reports_no_data_empty_result_title'),
      description: t('new_reports_no_data_empty_result_description'),
    },
    unsupported_profiles: {
      title: t('new_reports_no_data_unsupported_profiles_title'),
      description: t('new_reports_no_data_unsupported_profiles_description'),
    },
    insufficient_permissions: {
      title: t('new_reports_no_data_insufficient_permissions_title'),
      description: t('new_reports_no_data_insufficient_permissions_description'),
    },
    disconnected: {
      title: t('new_reports_no_data_disconnected_title'),
      description: t('new_reports_no_data_disconnected_description'),
    },
    no_profiles_selected: {
      title: t('new_reports_no_data_no_profiles_selected_title'),
      description: t('new_reports_no_data_no_profiles_selected_description'),
    },
    no_compatible_profiles: {
      title: t('new_reports_no_data_no_compatible_profiles_title'),
      description: t('new_reports_no_data_no_compatible_profiles_description', { platform: platformLabel ?? '' }),
    },
    error: {
      title: t('new_reports_no_data_error_title'),
      description: t('new_reports_no_data_error_description'),
    },
  };

  const message = reason ? reasonMessages[reason] : reasonMessages.empty_result;

  if (reason && PROFILE_REASONS.includes(reason)) {
    return (
      <NoProfilesContainer data-testid="module-no-profiles-state">
        <NoProfilesIcon>
          <Icon name="activity" />
        </NoProfilesIcon>
        <NoProfilesTitle>{message.title}</NoProfilesTitle>
        <NoProfilesDescription>{message.description}</NoProfilesDescription>
      </NoProfilesContainer>
    );
  }

  return (
    <NoDataContainer>
      <NoDataTitle>{message.title}</NoDataTitle>
      <NoDataDescription>{message.description}</NoDataDescription>
    </NoDataContainer>
  );
};
